import React, { useEffect, useMemo, useRef, useState } from "react";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { apiErrorMessage } from "../../helper/apiError";
import {
  FORM_DATE_TIME_FORMAT,
  reminderDateToFormValue,
} from "../../helper/reminderDate";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Chip,
  CircularProgress,
  Divider,
  FormGroup,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  styled,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import OutlinedInputField from "../../component/inputfiled/OutlinedInput";
import PhoneInputWithCountryCode from "../../component/inputfiled/PhoneInputWithCountryCode";
import {
  ErrorMessage,
  Field,
  FieldArray,
  Form,
  Formik,
  setNestedObjectValues,
} from "formik";
import OutlinedTextAreaField from "../../component/inputfiled/OutlinedTextedArea";
import AddIcon from "@mui/icons-material/Add";

import MyDatePicker from "../../component/datepicker/OutlinedDatepicker";
import dayjs from "dayjs";
import RemoveIcon from "@mui/icons-material/Remove";
import CustomButton from "../../component/button/button";
import Previews from "../../component/dropzone/Mydropzone";
import Mylogodropzone from "../../component/dropzone/Mylogodropzone";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  CreateUniversityService,
  EditUniversityService,
} from "../../Redux/service/SettingService";
import moment from "moment";
import CustomSelect from "../../component/select field/OutlinedSelectField";
import {
  GetContractTypeAction,
  GetCountryAction,
  GetCurrencyAction,
  GetOrganizationAction,
  GetProgramAction,
  GetStateListAction,
} from "../../Redux/action/SettingAction";
import { buildUniversityValidationSchema } from "./ValidationConstant";
import { GetDegreeAction } from "../../Redux/action/ApplicationAction";
import MultiSelect from "../../component/select field/MultiSelectWithAllOption";
import OnlyDatePicker from "../../component/datepicker/MyDatepicker";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import {
  convertToRaw,
  convertFromHTML,
  ContentState,
  EditorState,
} from "draft-js";

const NoPaddingGridItem = styled(Grid)({
  paddingTop: "0px !important",
});

const CreateUniversityPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formikRef = useRef(null);
  const childRef = useRef(null);
  const logochildRef = useRef(null);

  const datetimepickerRef = useRef(null);

  const { id } = useParams();

  const [Edit, setEdit] = useState(id ? true : false);

  const [prefieldData, setPrefieldData] = useState();

  const [FeeWavier, setFeeWavier] = useState("");

  const [contactPerson, setContactPerson] = useState([]);

  const [CommissionsAndPrograms, setCommissionsAndPrograms] = useState();

  const [reminders, setReminders] = useState([]);

  const [Programlist, setProgramlist] = useState([]);

  const [formLoading, setFormLoading] = useState(false);

  const [Degreelist, setDegreelist] = useState([]);

  const [Countrylist, setCountrylist] = useState([]);

  const [Currencylist, setCurrencylist] = useState([]);

  const [contractTypelist, setContractTypelist] = useState([]);

  const [Organizationlist, setOrganizationlist] = useState([]);

  const [statelist, setStatelist] = useState([]);

  const [editorState, setEditorState] = useState("");

  const [b_description, setB_Description] = useState();

  const [commissionType, setCommissionType] = useState("");

  const DegreelistState = useSelector(
    (state) => state.application?.degree?.data?.degrees
  );

  const CountrylistState = useSelector(
    (state) => state.setting?.countryCount?.data?.data
  );

  const CurrencylistState = useSelector(
    (state) => state.setting?.GetCurrencyList?.data?.currencies
  );
  // console.log(CurrencylistState);

  const ContractTypeListState = useSelector(
    (state) => state.setting?.contractType?.data?.data
  );

  const StateListState = useSelector(
    (state) => state.setting?.state?.data?.data
  );

  const OrganizationlistState = useSelector(
    (state) => state.setting?.organization?.data?.organizations
  );

  // console.log(OrganizationlistState);

  useEffect(() => {
    const list =
      OrganizationlistState?.map(({ organizationName, ...rest }) => ({
        title: organizationName,
        ...rest,
      })) || [];
    list.sort((a, b) =>
      (a.title || "").localeCompare(b.title || "", undefined, {
        sensitivity: "base",
      })
    );
    setOrganizationlist(list);
  }, [OrganizationlistState]);

  useEffect(() => {
    let data = {
      page: 1,
      limit: 0,
    };
    dispatch(GetOrganizationAction(data));
    dispatch(GetCountryAction());
    dispatch(GetCurrencyAction());
    dispatch(GetContractTypeAction());
    dispatch(GetDegreeAction());
  }, []);

  useEffect(() => {
    setStatelist(
      StateListState?.map(({ name, ...rest }) => ({
        title: name,
        ...rest,
      }))
    );
  }, [StateListState]);

  useEffect(() => {
    setDegreelist(
      DegreelistState?.map(({ name, ...rest }) => ({
        title: name,
        ...rest,
      }))
    );
  }, [DegreelistState]);

  useEffect(() => {
    // console.log(CountrylistState)
    setCountrylist(
      CountrylistState?.map(({ country, ...rest }) => ({
        title: country,
        _id: country,
        ...rest,
      }))
    );
  }, [CountrylistState]);

  useEffect(() => {
    // console.log(CountrylistState)
    setCurrencylist(
      CurrencylistState?.map(({ name, symbol, ...rest }) => ({
        title: `${name}(${symbol})`,
        symbol: symbol,
        ...rest,
      }))
    );
    console.log(CurrencylistState?.map(({ name, symbol, ...rest }) => ({
      title: `${name}(${symbol})`,
      symbol: symbol,
      ...rest,
    })))
  }, [CurrencylistState]);

  // set default currency to USD (for Create mode) once currencies load
  useEffect(() => {
    if (!Edit && Currencylist?.length && formikRef.current) {
      const defaultCurrencyObj = Currencylist.find(
        (c) =>
          c.code === "USD"

      );
      if (defaultCurrencyObj?._id) {
        formikRef.current.setFieldValue("currency", defaultCurrencyObj._id);
      }
    }
  }, [Currencylist, Edit]);
  useEffect(() => {
    // console.log(CountrylistState)
    setContractTypelist(
      ContractTypeListState?.map(({ contractType, ...rest }) => ({
        title: contractType,
        ...rest,
      }))
    );
  }, [ContractTypeListState]);

  useEffect(() => {
    dispatch(GetProgramAction());
  }, []);

  const ProgramlistState = useSelector(
    (state) => state.setting?.program?.data?.programs
  );
  useEffect(() => {
    const updatedData = ProgramlistState?.map(({ program, ...rest }) => ({
      title: program,
      ...rest,
    }));
    setProgramlist(updatedData);
  }, [ProgramlistState]);

  const EditUniversitydataState = useSelector(
    (state) => state.setting?.university?.data?.universities
  );
  useEffect(() => {
    setPrefieldData(
      EditUniversitydataState?.filter((data) => data._id === id)?.[0]
    );

    setFeeWavier(
      EditUniversitydataState?.filter((data) => data._id === id)?.[0]
        ?.feverNotes
    );

    setReminders(
      EditUniversitydataState?.filter(
        (data) => data._id === id
      )?.[0]?.reminders?.map((data) => {
        let json = {
          _id: data._id,
          text: data.text,
          // A reminder that was never given a resend date comes back as null;
          // moment.unix(null) is the epoch, not "empty".
          reminderDateTime: reminderDateToFormValue(data.reminderDateTime),
          resendDateTime: reminderDateToFormValue(data.resendDateTime),
        };
        return json;
      })
    );
    setContactPerson(
      EditUniversitydataState?.filter(
        (data) => data._id === id
      )?.[0]?.contactPerson?.map((data) => {
        let json = {
          designation: data.designation,
          email: data.email,
          name: data.name,
          phone: data.phone,
          universityDesignation: data.universityDesignation,
          isPrimary: data.isPrimary
        };
        return json;
      })
    );
    console.log(
      EditUniversitydataState?.filter((data) => data._id === id)?.[0],
      "checking value for contact person"
    );

    setCommissionsAndPrograms(
      EditUniversitydataState?.filter(
        (data) => data._id === id
      )?.[0]?.commissionsAndPrograms?.map((data) => {
        let json = {
          program: data?.program.map((data) => {
            return data?._id;
          }),
          degree: data?.degree?._id,
          commissionType: data.commissionType,
          value: data.commissionType === "S" ? 0 : data.value,
          duration: data.duration,
          customValue: data.customValue,
          paymentCycle: data.paymentCycle,
          termsAndCondition: data.termsAndCondition,
          termsAndConditionForOrg: data.termsAndConditionForOrg,
        };
        return json;
      })
    );

    // setCommissionType(
    //   EditUniversitydataState?.filter(
    //     (data) => data._id === id
    //   )?.[0]?.commissionsAndPrograms?.map((data) => {
    //     let json = {
    //       program: data?.program.map((data) => {
    //         return data?._id;
    //       }),
    //       degree: data?.degree?._id,
    //       commissionType: data.commissionType,
    //       value: data.value,
    //       duration: data.duration,
    //       paymentCycle: data.paymentCycle,
    //       termsAndCondition: data.termsAndCondition,
    //       termsAndConditionForOrg: data.termsAndConditionForOrg,
    //     };
    //     return json;
    //   })
    // )

    if (Edit) {
      const html = EditUniversitydataState?.find(
        (data) => data._id === id
      )?.description;

      if (html) {
        const contentBlock = htmlToDraft(html);
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock.contentBlocks,
            contentBlock.entityMap
          );
          setEditorState(EditorState.createWithContent(contentState));
        }
      }
    }

    // console.log(EditUniversitydataState?.filter((data) => data._id === id)?.[0])
  }, [Edit, EditUniversitydataState, id]);
  // handle form submit
  /**
   * Friendly names for the required fields, so a failed save can say what is
   * actually missing instead of leaving the user staring at a dead button.
   */
  // Commissions & programs are only mandatory when editing an existing
  // university - the create form starts with a blank commission row.
  const validationSchema = useMemo(
    () => buildUniversityValidationSchema({ isEdit: Edit }),
    [Edit]
  );

  const FIELD_LABELS = {
    name: "Name of the university",
    country: "Country",
    state: "State",
    contractType: "Contract type",
    currency: "Currency",
    promotedPrograms: "Promoted programs",
    commissionsAndPrograms: "Commissions and programs",
  };

  const describeMissingFields = (validationErrors) =>
    Object.keys(validationErrors)
      .map((field) => FIELD_LABELS[field] || field)
      .join(", ");

  /** Brings the first invalid field into view - the form is taller than the screen. */
  const scrollToFirstError = (validationErrors) => {
    const first = Object.keys(validationErrors)[0];
    if (!first) return;
    const element =
      document.querySelector(`[name="${first}"]`) ||
      document.getElementById(first);
    element?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  /**
   * Save was a plain `type="submit"`, so when validation failed Formik stopped
   * silently: no request, no message, and the offending field (contract type,
   * currency or promoted programs) sits far below the fold. Validate first and
   * say what is missing.
   */
  const handleValidatedSubmit = async (event, formikHandleSubmit) => {
    event.preventDefault();

    const validationErrors = await formikRef.current.validateForm();

    if (Object.keys(validationErrors).length > 0) {
      // Show the inline messages even on fields the user never touched.
      formikRef.current.setTouched(
        setNestedObjectValues(validationErrors, true)
      );
      dispatch(
        showSnackbar(
          `Please fill the required fields: ${describeMissingFields(
            validationErrors
          )}`,
          "error"
        )
      );
      scrollToFirstError(validationErrors);
      return;
    }

    formikHandleSubmit(event);
  };

  /**
   * Program ids already picked by a DIFFERENT commission entry.
   *
   * A program may belong to only one commission entry - the server rejects the
   * save otherwise - so the ones already spoken for are greyed out in the list
   * instead of letting the user pick them and hit an error.
   */
  const programsUsedElsewhere = (commissions, currentIndex) => {
    const used = new Set();

    (commissions || []).forEach((commission, index) => {
      if (index === currentIndex) return;
      (commission?.program || []).forEach((programId) =>
        used.add(String(programId))
      );
    });

    return used;
  };

  /** Options for one commission row: this degree's programs, minus the taken ones. */
  const programOptionsFor = (values, index) => {
    const used = programsUsedElsewhere(values.commissionsAndPrograms, index);

    return (Programlist || [])
      .filter(
        (prog) =>
          id === prog.university?._id &&
          values?.commissionsAndPrograms?.[index]?.degree === prog.degree?._id
      )
      .map(({ email, ...rest }) => ({
        title: email,
        ...rest,
        disabled: used.has(String(rest._id)),
      }));
  };

  const handleFormSubmit = async (values, formType) => {
    // //(values, formType, formikRef.current);

    setFormLoading(true);

    if (!Edit) {
      await CreateUniversityService(values)
        .then((res) => {
          if (res.status === 200) {
            //(res);
            setFormLoading(false);

            dispatch(showSnackbar(res.data.message, "success"));
            if (formType === "reset") {
              formikRef.current.resetForm();
            } else {
              navigate("/CAE/Universitylist");
            }
          }
        })
        .catch((e) => {
          setFormLoading(false);
          dispatch(showSnackbar(apiErrorMessage(e), "error"));
        });
    } else {
      // `replaceCommissions` marks the commission list as complete, so entries
      // the user deleted are removed server-side. Without it the update is
      // purely additive and a deleted commission comes back on reload.
      await EditUniversityService(
        { ...values, replaceCommissions: true },
        id
      )
        .then((res) => {
          if (res.status === 200) {
            //(res);
            setFormLoading(false);

            dispatch(showSnackbar(res.data.message, "success"));
            if (formType === "reset") {
              formikRef.current.resetForm();
            } else {
              navigate("/CAE/Universitylist");
            }
          }
        })
        .catch((e) => {
          setFormLoading(false);
          dispatch(showSnackbar(e.response?.data?.message, "error"));
        });
    }
  };
  // console.log(prefieldData);
  if (!prefieldData && !CommissionsAndPrograms && Edit) {
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <CircularProgress color="inherit" />
      </div>
    ); // You can replace this with a loading spinner
  }

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        name: Edit ? prefieldData?.name : "",
        country: Edit ? prefieldData?.country : "USA",
        state: Edit ? prefieldData?.state : "",
        city: Edit ? prefieldData?.city : "",
        address: Edit ? prefieldData?.address : "",
        websiteLink: Edit ? prefieldData?.websiteLink : "",
        contractExpireDate: Edit ? prefieldData?.contractExpireDate : null,
        documents: Edit ? prefieldData?.documents : [],
        images: Edit ? prefieldData?.images : [],
        logo: Edit ? prefieldData?.logo : "",
        currency: Edit ? prefieldData?.currency?._id : (Currencylist?.find(c => c.title === "USD")?._id || ""),
        isFever: Edit ? prefieldData?.isFever : "N",
        feverNotes: Edit ? prefieldData?.feverNotes : "",
        promotedPrograms: Edit
          ? prefieldData?.promotedPrograms?.map((data) => data._id)
          : [],

        organizationIds: Edit
          ? prefieldData?.organizationIds.map((id) => id._id)
          : [],

        reminders: Edit
          ? reminders?.map((reminder) => ({
            ...reminder,
            isNew: false, // Existing data is not new
          }))
          : [
            // {
            //   reminderDateTime: null,
            //   text: "",
            //   resendDateTime: null,
            //   isNew: true,
            // },
          ],

        contactPerson: Edit
          ? contactPerson
          : [
            {
              name: "",
              email: "",
              phone: "",
              designation: "",
              universityDesignation: "",
              isPrimary: false,
            },
          ],
        commissionsAndPrograms: Edit
          ? CommissionsAndPrograms
          : [
            {
              degree: "",
              program: [],
              commissionType: "",
              value: "",
              duration: "",
              customValue: [],
              paymentCycle: "",
              termsAndCondition: "",
              termsAndConditionForOrg: "",
            },
          ],
        notes: Edit ? prefieldData?.notes : "",
        description: Edit ? prefieldData?.description : "",
        contractType: Edit ? prefieldData?.contractType?._id : "",
      }}
      validationSchema={validationSchema}
      onSubmit={async (values, { resetForm }) => {
        if (values?.reminders?.[0]?.reminderDateTime === null) {
          delete values["reminders"];
        }
        // if(values?.images)
        // {
        //   console.log(values?.images)
        //   values.images=values.images?.map((img)=>img.url)

        // }

        // console.log(values);

        // return
        //(values);

        handleFormSubmit(values, "submit");
      }}
    >
      {({
        values,
        errors,
        handleBlur,
        handleChange,
        touched,
        handleSubmit,
        setFieldValue,
        resetForm,
      }) => (
        <Form
          className=""
          onSubmit={(event) => handleValidatedSubmit(event, handleSubmit)}
        >
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item lg={6} xs={12}>
              <div className="d-flex align-items-center">
                <IconButton onClick={() => navigate(-1)}>
                  <ArrowBackIcon />
                </IconButton>
                <Typography
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W600}
                  fontSize={fontSize.h2.small}
                >
                  Settings
                </Typography>
                <Typography
                  className="px-2 pt-1"
                  fontFamily={FontFamily.Poppins}
                  fontSize={fontSize.h4.medium}
                  fontWeight={fontWeight.W300}
                  color={ThemeColor.GREY}
                >
                  {!Edit ? "Create New" : "Edit"} university
                </Typography>
              </div>
            </Grid>
            <Grid item lg={6} xs={12}>
              {(window.sessionStorage.getItem("user_role_type") === "admin" ||
                window.sessionStorage.getItem("user_role_type") === "user" ||
                (window.sessionStorage.getItem("user_role_type") === "agent" &&
                  window.sessionStorage.getItem("role") === "admin")) && (
                <div className="d-flex justify-content-end align-items-center gap-2 w-100">
                  <CustomButton
                    variant="contained"
                    type="submit"
                    backgroundColor={ThemeColor.PURPLE}
                    color={ThemeColor.WHITE}
                    loading={formLoading}
                  >
                    {!Edit ? "Save University" : "Save Changes"}
                  </CustomButton>
                  {Edit ? (
                    <CustomButton
                      variant="contained"
                      type="button"
                      backgroundColor={ThemeColor.RED}
                      color={ThemeColor.WHITE}
                      loading={formLoading}
                      onClick={() => {
                        if (childRef.current) {
                          childRef.current.someFunction(
                            prefieldData?.documents
                          );
                        }
                        if (logochildRef.current) {
                          logochildRef.current.someFunction(
                            [{ preview: prefieldData?.logo }]
                          );
                        }
                        resetForm();
                      }}
                    >
                      Cancel Changes
                    </CustomButton>
                  ) : (
                    <CustomButton
                      variant="contained"
                      type="button"
                      backgroundColor={ThemeColor.PURPLE}
                      color={ThemeColor.WHITE}
                      loading={formLoading}
                      onClick={async () => {
                        // Same validation and feedback as the normal submit -
                        // this button does not go through Formik's onSubmit.
                        const validationErrors =
                          await formikRef.current.validateForm();
                        if (Object.keys(validationErrors).length > 0) {
                          formikRef.current.setTouched(
                            setNestedObjectValues(validationErrors, true)
                          );
                          dispatch(
                            showSnackbar(
                              `Please fill the required fields: ${describeMissingFields(
                                validationErrors
                              )}`,
                              "error"
                            )
                          );
                          scrollToFirstError(validationErrors);
                          return;
                        }
                        handleFormSubmit(values, "reset");
                      }}
                    >
                      Add Another University
                    </CustomButton>
                  )}
                </div>
              )}
            </Grid>
          </Grid>
          <div className="container">
            <Grid container spacing={2}>
                {/* grid for right basic content */}
                <Grid item lg={8}>
                  <Typography
                    align="center"
                    fontFamily={FontFamily.Poppins}
                    fontWeight={fontWeight.W600}
                    fontSize={fontSize.h3.medium}
                    color={ThemeColor.PURPLE}
                  >
                    {!Edit ? "Add" : "Edit"} New university
                  </Typography>

                  <Grid container spacing={2} className="mt-4">
                    <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            Name of the university *
                          </Typography>
                          <OutlinedInputField
                            value={values.name}
                            name={"name"}
                            onChange={handleChange}
                            placeholder="Enter name of university"
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.name}
                              </Typography>
                            }
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>
                    <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            Country *
                          </Typography>
                          <CustomSelect
                            value={Countrylist && values?.country}
                            name={"country"}
                            multiple={false}
                            option={Countrylist}
                            onChange={(e) => {
                              setFieldValue("country", e.target.value);
                              // dispatch(GetStateListAction(e.target.value))
                            }}
                            label={"Country"}
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.country}
                              </Typography>
                            }
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>
                    <NoPaddingGridItem item lg={6} md={6} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            State *
                          </Typography>
                          <CustomSelect
                            value={
                              Countrylist && values?.country && values?.state
                            }
                            name={"state"}
                            multiple={false}
                            // defaultValue={"United States of America (USA)"}
                            // option={[
                            //   { _id: "Alabama", title: "Alabama" },
                            //   { _id: "Alaska", title: "Alaska" },
                            //   { _id: "Arizona", title: "Arizona" },
                            //   { _id: "Arkansas", title: "Arkansas" },
                            //   { _id: "California", title: "California" },
                            //   { _id: "Colorado", title: "Colorado" },
                            //   { _id: "Connecticut", title: "Connecticut" },
                            //   { _id: "Delaware", title: "Delaware" },
                            //   { _id: "Florida", title: "Florida" },
                            //   { _id: "Georgia", title: "Georgia" },
                            //   { _id: "Hawaii", title: "Hawaii" },
                            //   { _id: "Idaho", title: "Idaho" },
                            //   { _id: "Illinois", title: "Illinois" },
                            //   { _id: "Indiana", title: "Indiana" },
                            //   { _id: "Iowa", title: "Iowa" },
                            //   { _id: "Kansas", title: "Kansas" },
                            //   { _id: "Kentucky", title: "Kentucky" },
                            //   { _id: "Louisiana", title: "Louisiana" },
                            //   { _id: "Maine", title: "Maine" },
                            //   { _id: "Maryland", title: "Maryland" },
                            //   { _id: "Massachusetts", title: "Massachusetts" },
                            //   { _id: "Michigan", title: "Michigan" },
                            //   { _id: "Minnesota", title: "Minnesota" },
                            //   { _id: "Mississippi", title: "Mississippi" },
                            //   { _id: "Missouri", title: "Missouri" },
                            //   { _id: "Montana", title: "Montana" },
                            //   { _id: "Nebraska", title: "Nebraska" },
                            //   { _id: "Nevada", title: "Nevada" },
                            //   { _id: "New Hampshire", title: "New Hampshire" },
                            //   { _id: "New Jersey", title: "New Jersey" },
                            //   { _id: "New Mexico", title: "New Mexico" },
                            //   { _id: "New York", title: "New York" },
                            //   {
                            //     _id: "North Carolina",
                            //     title: "North Carolina",
                            //   },
                            //   { _id: "North Dakota", title: "North Dakota" },
                            //   { _id: "Ohio", title: "Ohio" },
                            //   { _id: "Oklahoma", title: "Oklahoma" },
                            //   { _id: "Oregon", title: "Oregon" },
                            //   { _id: "Pennsylvania", title: "Pennsylvania" },
                            //   { _id: "Rhode Island", title: "Rhode Island" },
                            //   {
                            //     _id: "South Carolina",
                            //     title: "South Carolina",
                            //   },
                            //   { _id: "South Dakota", title: "South Dakota" },
                            //   { _id: "Tennessee", title: "Tennessee" },
                            //   { _id: "Texas", title: "Texas" },
                            //   { _id: "Utah", title: "Utah" },
                            //   { _id: "Vermont", title: "Vermont" },
                            //   { _id: "Virginia", title: "Virginia" },
                            //   { _id: "Washington", title: "Washington" },
                            //   { _id: "West Virginia", title: "West Virginia" },
                            //   { _id: "Wisconsin", title: "Wisconsin" },
                            //   { _id: "Wyoming", title: "Wyoming" },
                            // ]}
                            option={
                              Countrylist &&
                              values.country &&
                              Countrylist?.filter(
                                (data) => data.title === values.country
                              )?.[0]?.states?.map((state) => ({
                                title: state,
                                _id: state,
                              }))
                            }
                            onChange={(e) => {
                              setFieldValue("state", e.target.value);
                            }}
                            label={"Select State"}
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.state}
                              </Typography>
                            }
                          />
                          {/* <OutlinedInputField
                            value={values.state}
                            name={"state"}
                            onChange={handleChange}
                            placeholder="Enter your details...."
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.state}
                              </Typography>
                            }
                          /> */}
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>
                    <NoPaddingGridItem item lg={6} md={6} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            City
                          </Typography>
                          <OutlinedInputField
                            value={values.city}
                            name={"city"}
                            onChange={handleChange}
                            placeholder="Enter Your City"
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.city}
                              </Typography>
                            }
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>
                    <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            Currency *
                          </Typography>
                          <CustomSelect
                            value={Currencylist && values?.currency}
                            name={"currency"}
                            multiple={false}
                            option={Currencylist}
                            onChange={(e) => {
                              setFieldValue("currency", e.target.value);
                              // dispatch(GetStateListAction(e.target.value))
                            }}
                            label={"Select Currency"}
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.currency}
                              </Typography>
                            }
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>
                    <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            Contract Type *
                          </Typography>
                          <CustomSelect
                            value={contractTypelist ? values?.contractType : ""}
                            name={"contractType"}
                            multiple={false}
                            // defaultValue={"United States of America (USA)"}
                            // option={[
                            //   { _id: "Direct", title: "Direct" },
                            //   { _id: "Kaplan", title: "Kaplan" },
                            //   { _id: "EAG", title: "EAG" },
                            //   { _id: "EduCo.", title: "EduCo." },
                            //   { _id: "Shorelight", title: "Shorelight" },
                            // ]}
                            option={contractTypelist}
                            onChange={(e) => {
                              setFieldValue("contractType", e.target.value);
                            }}
                            label={"Select Contract Type"}
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.contractType}
                              </Typography>
                            }
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>

                    <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            Promoted Degree *
                          </Typography>
                          <CustomSelect
                            value={Degreelist ? values?.promotedPrograms : []}
                            name={"promotedPrograms"}
                            multiple={true}
                            // defaultValue={"United States of America (USA)"}
                            option={Degreelist}
                            onChange={(e) => {
                              setFieldValue("promotedPrograms", e.target.value);
                            }}
                            label={"Select Promoted Programs"}
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.promotedPrograms}
                              </Typography>
                            }
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>
                    <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            Fee Waiver
                          </Typography>
                          <CustomSelect
                            value={values?.isFever}
                            name={"isFever"}
                            option={[
                              { title: "Yes", _id: "Y" },
                              { title: "No", _id: "N" },
                            ]}
                            onChange={(e) => {
                              setFeeWavier(e.target.value);
                              setFieldValue("isFever", e.target.value);
                            }}
                            label={"Select Fee Waiver"}
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.isFever}
                              </Typography>
                            }
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>

                    {FeeWavier === "true" && (
                      <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                        <Tooltip title="feverNotes">
                          <FormGroup style={{}}>
                            <div className="">
                              <OutlinedTextAreaField
                                multiline={true}
                                minRows={4}
                                // disabled={
                                //   window.sessionStorage.getItem(
                                //     "user_role_type"
                                //   ) === "admin" ||
                                //   window.sessionStorage.getItem(
                                //     "user_role_type"
                                //   ) === "user"
                                //     ? false
                                //     : true
                                // }
                                padding={"0px 0px 5px 0px"}
                                value={values.feverNotes}
                                label={"Enter Fever Notes"}
                                onChange={handleChange}
                                name={"feverNotes"}
                                placeholder="Enter fever notes"
                                fullWidth={true}
                                helperText={
                                  <Typography
                                    align="left"
                                    // className="px-3"
                                    color={ThemeColor.RED}
                                    fontSize={fontSize.h4.medium}
                                    fontFamily={FontFamily.Lato}
                                    fontWeight={fontWeight.W500}
                                  >
                                    {errors.feverNotes}
                                  </Typography>
                                }
                              />
                            </div>
                          </FormGroup>
                        </Tooltip>
                      </NoPaddingGridItem>
                    )}

                    <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            Campus Address
                          </Typography>
                          <OutlinedTextAreaField
                            multiline={true}
                            minRows={4}
                            value={values.address}
                            onChange={handleChange}
                            name={"address"}
                            placeholder="Enter Your Address"
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.address}
                              </Typography>
                            }
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>
                    <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                      <FormGroup style={{}}>
                        <div className="">
                          <Typography
                            className="mb-2"
                            sx={{
                              fontWeight: 520,
                              fontSize: "0.9rem",
                              letterSpacing: "0.00938em",
                              fontFamily: "Lato !important",
                            }}
                          >
                            Website Link
                          </Typography>
                          <OutlinedInputField
                            value={values.websiteLink}
                            onChange={handleChange}
                            name={"websiteLink"}
                            placeholder="Enter Your Details"
                            fullWidth={true}
                            helperText={
                              <Typography
                                align="left"
                                // className="px-3"
                                color={ThemeColor.RED}
                                fontSize={fontSize.h4.medium}
                                fontFamily={FontFamily.Lato}
                                fontWeight={fontWeight.W500}
                              >
                                {errors.websiteLink}
                              </Typography>
                            }
                          />
                        </div>
                      </FormGroup>
                    </NoPaddingGridItem>

                    <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                      <FieldArray name="reminders">
                        {({ push, remove }) => (
                          <div>
                            {values.reminders?.map((reminder, index) => (
                              <Grid
                                container
                                spacing={2}
                                className="mt-4"
                                key={index}
                              >
                                {index > 0 && (
                                  <NoPaddingGridItem
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="d-flex align-items-center"
                                  >
                                    <div className="w-100 mt-2 mb-3">
                                      <Divider>
                                        <Chip
                                          label={`${index + 1
                                            } Reminder Details `}
                                          size="small"
                                        />
                                      </Divider>
                                    </div>
                                  </NoPaddingGridItem>
                                )}
                                <NoPaddingGridItem
                                  item
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  xs={12}
                                >
                                  <FormGroup style={{}}>
                                    <div className="">
                                      <Typography
                                        className="mb-2"
                                        sx={{
                                          fontWeight: 520,
                                          fontSize: "0.9rem",
                                          letterSpacing: "0.00938em",
                                          fontFamily: "Lato !important",
                                        }}
                                      >
                                        Reminder Date & Time
                                      </Typography>
                                      <MyDatePicker
                                        ref={datetimepickerRef}
                                        minDate={dayjs().startOf("day")}
                                        label="Enter Your Details"
                                        // value={dayjs(values.contactPerson[index].reminder_date).toDate()}

                                        value={
                                          values.reminders[index]
                                            ?.reminderDateTime
                                            ? dayjs(
                                              values.reminders[index]
                                                ?.reminderDateTime
                                            ).isValid()
                                              ? dayjs(
                                                values.reminders[index]
                                                  ?.reminderDateTime
                                              )
                                              : null
                                            : null
                                        }
                                        onChange={(date) => {
                                          setFieldValue(
                                            `reminders[${index}].reminderDateTime`,
                                            dayjs(date).format(
                                              FORM_DATE_TIME_FORMAT
                                            )
                                          );
                                        }}
                                        helperText={
                                          <Typography
                                            align="left"
                                            // className="px-3"
                                            color={ThemeColor.RED}
                                            fontSize={fontSize.h4.medium}
                                            fontFamily={FontFamily.Lato}
                                            fontWeight={fontWeight.W500}
                                          >
                                            {
                                              errors.reminders?.[index]
                                                ?.reminderDateTime
                                            }
                                          </Typography>
                                        }
                                      />
                                    </div>
                                  </FormGroup>
                                </NoPaddingGridItem>

                                <NoPaddingGridItem
                                  item
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  xs={12}
                                >
                                  <FormGroup style={{}}>
                                    <div className="">
                                      <Typography
                                        className="mb-2"
                                        sx={{
                                          fontWeight: 520,
                                          fontSize: "0.9rem",
                                          letterSpacing: "0.00938em",
                                          fontFamily: "Lato !important",
                                        }}
                                      >
                                        Resend Date & Time
                                       
                                      </Typography>
                                      <MyDatePicker
                                        ref={datetimepickerRef}
                                        minDate={dayjs().startOf("minute")}
                                        label="Enter Your Details"
                                        // value={dayjs(values.contactPerson[index].reminder_date).toDate()}
                                        value={
                                          values.reminders[index]
                                            ?.resendDateTime
                                            ? dayjs(
                                              values.reminders[index]
                                                ?.resendDateTime
                                            ).isValid()
                                              ? dayjs(
                                                values.reminders[index]
                                                  ?.resendDateTime
                                              )
                                              : null
                                            : null
                                        }
                                        onChange={(date) => {
                                          setFieldValue(
                                            `reminders[${index}].resendDateTime`,
                                            dayjs(date).format(
                                              FORM_DATE_TIME_FORMAT
                                            )
                                          );
                                        }}
                                        helperText={
                                          <Typography
                                            align="left"
                                            // className="px-3"
                                            color={ThemeColor.RED}
                                            fontSize={fontSize.h4.medium}
                                            fontFamily={FontFamily.Lato}
                                            fontWeight={fontWeight.W500}
                                          >
                                            {
                                              errors.reminders?.[index]
                                                ?.resendDateTime
                                            }
                                          </Typography>
                                        }
                                      />
                                    </div>
                                  </FormGroup>
                                </NoPaddingGridItem>

                                <NoPaddingGridItem
                                  item
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  xs={12}
                                >
                                  <FormGroup style={{}}>
                                    <div className="">
                                      <Typography
                                        className="mb-2"
                                        sx={{
                                          fontWeight: 520,
                                          fontSize: "0.9rem",
                                          letterSpacing: "0.00938em",
                                          fontFamily: "Lato !important",
                                        }}
                                      >
                                        Reminder Note
                                      </Typography>
                                      <OutlinedInputField
                                        value={values.reminders[index].text}
                                        name={`reminders[${index}].text`}
                                        onChange={handleChange}
                                        placeholder="Enter Your Details"
                                        fullWidth={true}
                                        helperText={
                                          <Typography
                                            align="left"
                                            // className="px-3"
                                            color={ThemeColor.RED}
                                            fontSize={fontSize.h4.medium}
                                            fontFamily={FontFamily.Lato}
                                            fontWeight={fontWeight.W500}
                                          >
                                            {errors.reminders?.[index]?.text}
                                          </Typography>
                                        }
                                      />
                                    </div>
                                  </FormGroup>
                                </NoPaddingGridItem>
                                {index > 0 && (
                                  <NoPaddingGridItem
                                    item
                                    lg={3}
                                    md={3}
                                    sm={12}
                                    xs={12}
                                    className="d-flex align-items-center"
                                  >
                                    <div className="d-flex justify-content-start w-100 mt-3">
                                      <Typography
                                        className="px-2"
                                        fontSize={fontSize.h3.small}
                                        fontFamily={FontFamily.Lato}
                                        color={ThemeColor.BLACK}
                                        fontWeight={fontWeight.W600}
                                      >
                                        Delete Reminder
                                      </Typography>
                                      <IconButton
                                        className="form-icon"
                                        sx={{
                                          background: ThemeColor.RED,
                                          color: ThemeColor.WHITE,
                                        }}
                                        variant="contained"
                                        onClick={() => remove(index)}
                                      >
                                        <RemoveIcon />
                                      </IconButton>
                                    </div>
                                  </NoPaddingGridItem>
                                )}
                              </Grid>
                            ))}
                            <div className="d-flex justify-content-start w-100 mt-2 mb-3">
                              {values.reminders.length === 0 ? (
                                <Typography
                                  className="px-2"
                                  fontSize={fontSize.h3.small}
                                  fontFamily={FontFamily.Lato}
                                  color={ThemeColor.BLACK}
                                  fontWeight={fontWeight.W600}
                                >
                                  Add Reminder
                                </Typography>
                              ) : (
                                <Typography
                                  className="px-2"
                                  fontSize={fontSize.h3.small}
                                  fontFamily={FontFamily.Lato}
                                  color={ThemeColor.BLACK}
                                  fontWeight={fontWeight.W600}
                                >
                                  Add More Reminder
                                </Typography>
                              )}
                              <IconButton
                                className="form-icon"
                                sx={{
                                  background: ThemeColor.BLUE,
                                  color: ThemeColor.WHITE,
                                }}
                                onClick={() =>
                                  push({
                                    text: "",
                                    reminderDateTime: null,
                                    resendDateTime: null,
                                    isNew: true,
                                  })
                                }
                              >
                                <AddIcon />
                              </IconButton>
                            </div>
                          </div>
                        )}
                      </FieldArray>
                    </NoPaddingGridItem>
                  </Grid>
                </Grid>

                {/* grid for left docs uploading content */}
                <Grid item lg={4} xs={12}>
                  {window.sessionStorage.getItem("user_role_type") ===
                    "admin" && (
                      <div className="w-100 d-flex justify-content-center mt-4">
                        <Previews
                          // max3={true}
                          deleteShow={true}
                          mainText={"Supporting Documents"}
                          ref={childRef}
                          initialValue={values?.documents}
                          handleMydropzoneFile={(updatedFiles) => {
                            //(updatedFiles);
                            setFieldValue("documents", updatedFiles);
                          }}
                          helperText={
                            <Typography
                              align="left"
                              // className="px-3"
                              color={ThemeColor.RED}
                              fontSize={fontSize.h4.medium}
                              fontFamily={FontFamily.Lato}
                              fontWeight={fontWeight.W500}
                            >
                              {errors.documents}
                            </Typography>
                          }
                        />
                      </div>
                    )}

                  {window.sessionStorage.getItem("user_role_type") ===
                    "admin" && (
                      <div className="w-100 d-flex justify-content-center mt-4">
                        <Previews
                          deleteShow={true}
                          mainText={"Upload 3 images"}
                          text={"Only 3 images can be selected"}
                          max3={true}
                          ref={childRef}
                          initialValue={values?.images}
                          handleMydropzoneFile={(updatedFiles) => {
                            //(updatedFiles);
                            setFieldValue("images", updatedFiles);
                          }}
                          helperText={
                            <Typography
                              align="left"
                              // className="px-3"
                              color={ThemeColor.RED}
                              fontSize={fontSize.h4.medium}
                              fontFamily={FontFamily.Lato}
                              fontWeight={fontWeight.W500}
                            >
                              {errors.images}
                            </Typography>
                          }
                        />
                      </div>
                    )}

                  <div className="w-100 d-flex justify-content-center mt-4">
                    <Mylogodropzone
                      ref={logochildRef}
                      initialValue={Edit && [{ preview: values?.logo }]}
                      handleMydropzoneFile={(updatedFiles) => {
                        setFieldValue("logo", updatedFiles?.[0]?.url);
                      }}
                    // helperText={
                    //   <Typography
                    //     align="left"
                    //     // className="px-3"
                    //     color={ThemeColor.RED}
                    //     fontSize={fontSize.h4.medium}
                    //     fontFamily={FontFamily.Lato}
                    //     fontWeight={fontWeight.W500}
                    //   >
                    //     {errors.documents}
                    //   </Typography>
                    // }
                    />
                  </div>

                  <div className="w-100">
                    <Typography
                      className="mb-2"
                      sx={{
                        fontWeight: 520,
                        fontSize: "0.9rem",
                        letterSpacing: "0.00938em",
                        fontFamily: "Lato !important",
                      }}
                    >
                      Contract End Date
                    </Typography>
                    <OnlyDatePicker
                      views={["year", "month", "day"]}
                      label="Add Details"
                      // value={startDate}
                      value={
                        values.contractExpireDate
                          ? dayjs(values.contractExpireDate).isValid()
                            ? dayjs(values.contractExpireDate)
                            : null
                          : null
                      }
                      onChange={(date) => {
                        // setStartDate(date);
                        // if (endDate && date && endDate < date) {
                        //   setEndDate(null);
                        //   dispatch(
                        //     showSnackbar(
                        //       "End Date must be later than the Start Date. Please select a valid End Date.",
                        //       "error"
                        //     )
                        //   );
                        // }
                        setFieldValue(
                          `contractExpireDate`,
                          dayjs(date).format("YYYY-MM-DD")
                        );
                      }}
                      helperText={
                        <Typography
                          align="left"
                          // className="px-3"
                          color={ThemeColor.RED}
                          fontSize={fontSize.h4.medium}
                          fontFamily={FontFamily.Lato}
                          fontWeight={fontWeight.W500}
                        >
                          {errors.contractExpireDate}
                        </Typography>
                      }
                    />
                    {/* <MyDatePicker
                      label="Enter your details...."
                      // value={dayjs(values.contactPerson[index].reminder_date).toDate()}
                      onChange={(date) => {
                        setFieldValue(
                          `contractExpireDate`,
                          dayjs(date).format(FORM_DATE_TIME_FORMAT)
                        );
                      }}
                      value={
                        values.contractExpireDate
                          ? dayjs(values.contractExpireDate).isValid()
                            ? dayjs(values.contractExpireDate)
                            : null
                          : null
                      }
                      helperText={
                        <Typography
                          align="left"
                          // className="px-3"
                          color={ThemeColor.RED}
                          fontSize={fontSize.h4.medium}
                          fontFamily={FontFamily.Lato}
                          fontWeight={fontWeight.W500}
                        >
                          {errors.contractExpireDate}
                        </Typography>
                      }
                    /> */}
                  </div>
                </Grid>

                {/* grid for bottom contact person content */}
                <Grid item lg={12}>
                  <Typography
                    fontFamily={FontFamily.Poppins}
                    fontWeight={fontWeight.W600}
                    fontSize={fontSize.h3.medium}
                    color={ThemeColor.PURPLE}
                  >
                    Point of Contact Details
                  </Typography>
                  <FieldArray name="contactPerson">
                    {({ push, remove }) => (
                      <div>
                        {values.contactPerson.map((contact, index) => (
                          <Grid
                            container
                            spacing={2}
                            className="mt-4"
                            key={index}
                          >
                            {index > 0 && (
                              <NoPaddingGridItem
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className="d-flex align-items-center"
                              >
                                <div className="w-100 mt-2 mb-3">
                                  <Divider>
                                    <Chip
                                      label={`${index + 1
                                        } Contact Person Details `}
                                      size="small"
                                    />
                                  </Divider>
                                </div>
                              </NoPaddingGridItem>
                            )}
                            <NoPaddingGridItem
                              item
                              lg={3}
                              md={3}
                              sm={12}
                              xs={12}
                            >
                              <FormGroup style={{}}>
                                <div className="">
                                  <Typography
                                    className="mb-2"
                                    sx={{
                                      fontWeight: 520,
                                      fontSize: "0.9rem",
                                      letterSpacing: "0.00938em",
                                      fontFamily: "Lato !important",
                                    }}
                                  >
                                    Name
                                  </Typography>
                                  <OutlinedInputField
                                    value={values.contactPerson[index].name}
                                    name={`contactPerson[${index}].name`}
                                    onChange={handleChange}
                                    placeholder="Enter Your Details"
                                    fullWidth={true}
                                    helperText={
                                      <Typography
                                        align="left"
                                        // className="px-3"
                                        color={ThemeColor.RED}
                                        fontSize={fontSize.h4.medium}
                                        fontFamily={FontFamily.Lato}
                                        fontWeight={fontWeight.W500}
                                      >
                                        {errors.contactPerson?.[index]?.name}
                                      </Typography>
                                    }
                                  />
                                </div>
                              </FormGroup>
                            </NoPaddingGridItem>

                            <NoPaddingGridItem
                              item
                              lg={3}
                              md={3}
                              sm={12}
                              xs={12}
                            >
                              <FormGroup style={{}}>
                                <div className="">
                                  <Typography
                                    className="mb-2"
                                    sx={{
                                      fontWeight: 520,
                                      fontSize: "0.9rem",
                                      letterSpacing: "0.00938em",
                                      fontFamily: "Lato !important",
                                    }}
                                  >
                                    Email
                                  </Typography>
                                  <OutlinedInputField
                                    value={values.contactPerson[index].email}
                                    name={`contactPerson[${index}].email`}
                                    onChange={handleChange}
                                    placeholder="Enter Your Details"
                                    fullWidth={true}
                                    helperText={
                                      <Typography
                                        align="left"
                                        // className="px-3"
                                        color={ThemeColor.RED}
                                        fontSize={fontSize.h4.medium}
                                        fontFamily={FontFamily.Lato}
                                        fontWeight={fontWeight.W500}
                                      >
                                        {errors.contactPerson?.[index]?.email}
                                      </Typography>
                                    }
                                  />
                                </div>
                              </FormGroup>
                            </NoPaddingGridItem>
                            <NoPaddingGridItem
                              item
                              lg={3}
                              md={3}
                              sm={12}
                              xs={12}
                            >
                              <PhoneInputWithCountryCode
                                label="Phone No."
                                value={values.contactPerson[index]?.phone}
                                onChange={handleChange}
                                name={`contactPerson[${index}].phone`}
                                placeholder="Enter Your Details"
                                error={errors.contactPerson?.[index]?.phone}
                                fullWidth={true}
                              />
                            </NoPaddingGridItem>
                            {/* <NoPaddingGridItem
                              item
                              lg={3}
                              md={3}
                              sm={12}
                              xs={12}
                            >
                              <FormGroup style={{}}>
                                <div className="">
                                  <Typography
                                    className="mb-2"
                                    fontFamily={FontFamily.Lato}
                                    fontSize={fontSize.h3.medium}
                                    fontWeight={fontWeight.W400}
                                  >
                                    Designation
                                  </Typography>
                                  <OutlinedInputField
                                    value={
                                      values.contactPerson[index].designation
                                    }
                                    name={`contactPerson[${index}].designation`}
                                    onChange={handleChange}
                                    placeholder="Enter your details...."
                                    fullWidth={true}
                                    helperText={
                                      <Typography
                                        align="left"
                                        // className="px-3"
                                        color={ThemeColor.RED}
                                        fontSize={fontSize.h4.medium}
                                        fontFamily={FontFamily.Lato}
                                        fontWeight={fontWeight.W500}
                                      >
                                        {
                                          errors.contactPerson?.[index]
                                            ?.designation
                                        }
                                      </Typography>
                                    }
                                  />
                                </div>
                              </FormGroup>
                            </NoPaddingGridItem> */}

                            <NoPaddingGridItem
                              item
                              lg={3}
                              md={3}
                              sm={12}
                              xs={12}
                            >
                              <FormGroup style={{}}>
                                <div className="">
                                  <Typography
                                    className="mb-2"
                                    sx={{
                                      fontWeight: 520,
                                      fontSize: "0.9rem",
                                      letterSpacing: "0.00938em",
                                      fontFamily: "Lato !important",
                                    }}
                                  >
                                    Designation *
                                  </Typography>
                                  <CustomSelect
                                    value={
                                      values.contactPerson[index].designation
                                    }
                                    name={"contactPerson[${index}].designation"}
                                    // multiple={true}
                                    // defaultValue={"United States of America (USA)"}
                                    option={[
                                      {
                                        _id: "Director of Intl Admissions",
                                        title: "Director of Intl Admissions",
                                      },
                                      {
                                        _id: "Coordinator",
                                        title: "Coordinator",
                                      },
                                      { _id: "Accounts", title: "Accounts" },
                                    ]}
                                    onChange={(e) => {
                                      setFieldValue(
                                        `contactPerson[${index}].designation`,
                                        e.target.value
                                      );
                                    }}
                                    label={"Select Designation"}
                                    fullWidth={true}
                                    helperText={
                                      <Typography
                                        align="left"
                                        // className="px-3"
                                        color={ThemeColor.RED}
                                        fontSize={fontSize.h4.medium}
                                        fontFamily={FontFamily.Lato}
                                        fontWeight={fontWeight.W500}
                                      >
                                        {
                                          errors.contactPerson?.[index]
                                            ?.designation
                                        }
                                      </Typography>
                                    }
                                  />
                                </div>
                              </FormGroup>
                            </NoPaddingGridItem>

                            <NoPaddingGridItem
                              item
                              lg={3}
                              md={3}
                              sm={12}
                              xs={12}
                            >
                              <FormGroup style={{}}>
                                <div className="">
                                  <Typography
                                    className="mb-2"
                                    sx={{
                                      fontWeight: 520,
                                      fontSize: "0.9rem",
                                      letterSpacing: "0.00938em",
                                      fontFamily: "Lato !important",
                                    }}
                                  >
                                    University Designation
                                  </Typography>
                                  <OutlinedInputField
                                    value={
                                      values.contactPerson[index]
                                        .universityDesignation
                                    }
                                    name={`contactPerson[${index}].universityDesignation`}
                                    onChange={handleChange}
                                    placeholder="Enter Your Details"
                                    fullWidth={true}
                                    helperText={
                                      <Typography
                                        align="left"
                                        // className="px-3"
                                        color={ThemeColor.RED}
                                        fontSize={fontSize.h4.medium}
                                        fontFamily={FontFamily.Lato}
                                        fontWeight={fontWeight.W500}
                                      >
                                        {
                                          errors.contactPerson?.[index]
                                            ?.universityDesignation
                                        }
                                      </Typography>
                                    }
                                  />
                                </div>
                              </FormGroup>
                            </NoPaddingGridItem>

                            <NoPaddingGridItem
                              item
                              lg={3}
                              md={3}
                              sm={12}
                              xs={12}
                            >
                              <FormGroup style={{}}>
                                <div className="">
                                  <Typography
                                    className="mb-2"
                                    sx={{
                                      fontWeight: 520,
                                      fontSize: "0.9rem",
                                      letterSpacing: "0.00938em",
                                      fontFamily: "Lato !important",
                                    }}
                                  >
                                    Main Contact*
                                  </Typography>
                                  <CustomSelect
                                    value={
                                      values.contactPerson[index].isPrimary
                                    }
                                    name={"contactPerson[${index}].isPrimary"}
                                    // multiple={true}
                                    // defaultValue={"United States of America (USA)"}
                                    option={[
                                      { _id: false, title: "No" },
                                      { _id: true, title: "Yes" },
                                    ]}
                                    onChange={(e) => {
                                      setFieldValue(
                                        `contactPerson[${index}].isPrimary`,
                                        e.target.value
                                      );
                                    }}
                                    label={"Main Contact"}
                                    fullWidth={true}
                                    helperText={
                                      <Typography
                                        align="left"
                                        // className="px-3"
                                        color={ThemeColor.RED}
                                        fontSize={fontSize.h4.medium}
                                        fontFamily={FontFamily.Lato}
                                        fontWeight={fontWeight.W500}
                                      >
                                        {
                                          errors.contactPerson?.[index]
                                            ?.isPrimary
                                        }
                                      </Typography>
                                    }
                                  />
                                </div>
                              </FormGroup>
                            </NoPaddingGridItem>

                            {index > 0 && (
                              <NoPaddingGridItem
                                item
                                lg={3}
                                md={3}
                                sm={12}
                                xs={12}
                                className="d-flex align-items-center"
                              >
                                <div className="d-flex justify-content-start w-100 mt-3">
                                  <Typography
                                    className="px-2"
                                    fontSize={fontSize.h3.small}
                                    fontFamily={FontFamily.Lato}
                                    color={ThemeColor.BLACK}
                                    fontWeight={fontWeight.W600}
                                  >
                                    Delete Contact Person
                                  </Typography>
                                  <IconButton
                                    className="form-icon"
                                    sx={{
                                      background: ThemeColor.RED,
                                      color: ThemeColor.WHITE,
                                    }}
                                    variant="contained"
                                    onClick={() => remove(index)}
                                  >
                                    <RemoveIcon />
                                  </IconButton>
                                </div>
                              </NoPaddingGridItem>
                            )}
                          </Grid>
                        ))}
                        <div className="d-flex justify-content-end w-100 mt-3">
                          <Typography
                            className="px-2"
                            fontSize={fontSize.h3.medium}
                            fontFamily={FontFamily.Lato}
                            color={ThemeColor.BLACK}
                            fontWeight={fontWeight.W600}
                          >
                            Add Another Contact
                          </Typography>
                          <IconButton
                            className="form-icon"
                            sx={{
                              background: ThemeColor.BLUE,
                              color: ThemeColor.WHITE,
                            }}
                            onClick={() =>
                              push({
                                name: "",
                                email: "",
                                phone: "",
                                designation: "",
                                isPrimary: false,
                                universityDesignation: "",
                              })
                            }
                          >
                            <AddIcon />
                          </IconButton>
                        </div>
                      </div>
                    )}
                  </FieldArray>
                </Grid>

                <Grid item lg={12} xs={12}>
                  <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                    <FormGroup style={{}} className="w-100">
                      <div className="w-100">
                        <Typography
                          className="mb-2"
                          sx={{
                            fontWeight: 520,
                            fontSize: "0.9rem",
                            letterSpacing: "0.00938em",
                            fontFamily: "Lato !important",
                          }}
                        >
                          Notes (Admin only)
                        </Typography>
                        <OutlinedTextAreaField
                          multiline={true}
                          minRows={4}
                          value={values.notes}
                          name={"notes"}
                          onChange={handleChange}
                          placeholder="Enter Your Notes"
                          fullWidth={true}
                        />
                      </div>
                    </FormGroup>
                  </NoPaddingGridItem>
                </Grid>

                <Grid item lg={12}>
                  <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                    <FormGroup style={{}} className="w-100 mb-2">
                      <div className="w-100">
                        <Typography
                          className="mb-2"
                          sx={{
                            fontWeight: 520,
                            fontSize: "0.9rem",
                            letterSpacing: "0.00938em",
                            fontFamily: "Lato !important",
                          }}
                        >
                          University Overview
                        </Typography>
                        {/* <OutlinedTextAreaField
                          multiline={true}
                          minRows={4}
                          value={values.description}
                          name={"description"}
                          onChange={handleChange}
                          placeholder="The description you add here will be visible to everyone."
                          fullWidth={true}
                        /> */}
                        <Editor
                          editorState={editorState}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          placeholder="The description you add here will be visible to everyone."
                          style={{ backgrond: "white" }}
                          editorStyle={{
                            color: "#164242",
                            background: "white",
                            height: "200px",
                          }}
                          onEditorStateChange={(e) => {
                            //(e);
                            setEditorState(e);
                          }}
                          onChange={(e) => {
                            setB_Description(
                              draftToHtml(
                                convertToRaw(editorState.getCurrentContent())
                              )
                            );
                            setFieldValue(
                              "description",
                              draftToHtml(
                                convertToRaw(editorState.getCurrentContent())
                              )
                            );
                          }}
                        />
                      </div>
                    </FormGroup>
                  </NoPaddingGridItem>
                </Grid>

                {
                  <NoPaddingGridItem item lg={12} md={12} sm={12} xs={12}>
                    <FormGroup style={{}}>
                      <div className="">
                        <Typography
                          className="mb-2 mt-4"
                          fontFamily={FontFamily.Poppins}
                          fontWeight={fontWeight.W600}
                          fontSize={fontSize.h3.medium}
                          color={ThemeColor.PURPLE}
                        // sx={{
                        //   // fontWeight: 520,
                        //   // fontSize: "0.9rem",
                        //   letterSpacing: "0.00938em",
                        //   fontFamily: "Lato !important",
                        // }}
                        >
                          Assign To Organization *
                        </Typography>
                        <MultiSelect
                          value={Organizationlist ? values.organizationIds : []}
                          onChange={(selectedOptions) =>
                            setFieldValue(`organizationIds`, selectedOptions)
                          }
                          name={"program"}
                          options={Organizationlist}
                          // onChange={(e) => {
                          //   setFieldValue(
                          //     `commissionsAndPrograms[${index}].program`,
                          //     e.target.value
                          //   );
                          // }}
                          // label={"Program"}
                          fullWidth={true}
                          helperText={
                            <Typography
                              align="left"
                              // className="px-3"
                              color={ThemeColor.RED}
                              fontSize={fontSize.h4.medium}
                              fontFamily={FontFamily.Lato}
                              fontWeight={fontWeight.W500}
                            >
                              {errors.organizationIds}
                            </Typography>
                          }
                        />
                      </div>
                    </FormGroup>
                  </NoPaddingGridItem>
                }

                {/* grid for bottom commision prog content */}
                {window.sessionStorage.getItem("user_role_type") === "admin" &&
                  Edit && (
                    <Grid item lg={12} xs={12} sm={12}>
                      <Typography
                        fontFamily={FontFamily.Poppins}
                        fontWeight={fontWeight.W600}
                        fontSize={fontSize.h3.medium}
                        color={ThemeColor.PURPLE}
                      >
                        Commission And Program
                      </Typography>
                      <FieldArray name="commissionsAndPrograms">
                        {({ push, remove }) => (
                          <div>
                            {values?.commissionsAndPrograms?.map(
                              (contact, index) => (
                                <Grid
                                  container
                                  spacing={2}
                                  className="mt-4"
                                  key={index}
                                >
                                  {index > 0 && (
                                    <NoPaddingGridItem
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      className="d-flex align-items-center"
                                    >
                                      <div className="w-100 mt-2 mb-3">
                                        <Divider>
                                          <Chip
                                            label={`${index + 1
                                              } commissionsAndPrograms Details `}
                                            size="small"
                                          />
                                        </Divider>
                                      </div>
                                    </NoPaddingGridItem>
                                  )}

                                  <NoPaddingGridItem
                                    item
                                    lg={4}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                  >
                                    <FormGroup style={{}}>
                                      <Typography
                                        className="mb-1"
                                        fontFamily={FontFamily.Lato}
                                        fontSize={fontSize.h3.medium}
                                        fontWeight={fontWeight.W400}
                                      >
                                        Degree Type
                                      </Typography>
                                      <div className="">
                                        <CustomSelect
                                          value={
                                            Degreelist &&
                                            values?.commissionsAndPrograms[
                                              index
                                            ]?.degree
                                          }
                                          name={`commissionsAndPrograms[${index}].degree`}
                                          multiple={false}
                                          option={Degreelist}
                                          onChange={(e) => {
                                            console.log(e.target.value);
                                            setFieldValue(
                                              `commissionsAndPrograms[${index}].degree`,
                                              e.target.value
                                            );
                                          }}
                                          fullWidth={true}
                                          label={"Degree"}
                                          helperText={
                                            <Typography
                                              align="left"
                                              // className="px-3"
                                              color={ThemeColor.RED}
                                              fontSize={fontSize.h4.medium}
                                              fontFamily={FontFamily.Lato}
                                              fontWeight={fontWeight.W500}
                                            >
                                              {
                                                errors.commissionsAndPrograms?.[
                                                  index
                                                ]?.degree
                                              }
                                            </Typography>
                                          }
                                        />
                                      </div>
                                    </FormGroup>
                                  </NoPaddingGridItem>

                                  {/* <NoPaddingGridItem
                                  item
                                  lg={4}
                                  md={4}
                                  sm={12}
                                  xs={12}
                                >
                                  <FormGroup style={{}} className="">
                                    <div className="w-100">
                                      <Typography
                                        className="mb-1"
                                        fontFamily={FontFamily.Lato}
                                        fontSize={fontSize.h3.medium}
                                        fontWeight={fontWeight.W400}
                                      >
                                        Program
                                      </Typography>
                                      <CustomSelect
                                        value={
                                          Programlist
                                            ? values.commissionsAndPrograms[
                                                index
                                              ]?.program
                                            : []
                                        }
                                        name={"program"}
                                        multiple={true}
                                        option={programOptionsFor(
                                          values,
                                          index
                                        )}
                                        onChange={(e) => {
                                          setFieldValue(
                                            `commissionsAndPrograms[${index}].program`,
                                            e.target.value
                                          );
                                        }}
                                        label={"Program"}
                                        fullWidth={true}
                                        helperText={
                                          <Typography
                                            align="left"
                                            // className="px-3"
                                            color={ThemeColor.RED}
                                            fontSize={fontSize.h4.medium}
                                            fontFamily={FontFamily.Lato}
                                            fontWeight={fontWeight.W500}
                                          >
                                            {
                                              errors.commissionsAndPrograms?.[
                                                index
                                              ]?.program
                                            }
                                          </Typography>
                                        }
                                      />
                                    </div>
                                  </FormGroup>
                                </NoPaddingGridItem> */}

                                  <NoPaddingGridItem
                                    item
                                    lg={4}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                  >
                                    <FormGroup style={{}} className="">
                                      <div className="w-100">
                                        <Typography
                                          className="mb-1"
                                          fontFamily={FontFamily.Lato}
                                          fontSize={fontSize.h3.medium}
                                          fontWeight={fontWeight.W400}
                                        >
                                          Program
                                        </Typography>
                                        <MultiSelect
                                          value={
                                            Programlist
                                              ? values.commissionsAndPrograms[
                                                index
                                              ]?.program
                                              : []
                                          }
                                          onChange={(selectedOptions) =>
                                            setFieldValue(
                                              `commissionsAndPrograms[${index}].program`,
                                              selectedOptions
                                            )
                                          }
                                          name={"program"}
                                          options={
                                            Programlist &&
                                            Programlist?.filter(
                                              (prog) =>
                                                id === prog.university._id &&
                                                values?.commissionsAndPrograms[
                                                  index
                                                ]?.degree === prog.degree?._id
                                            )?.map(({ email, ...rest }) => ({
                                              title: email,
                                              ...rest,
                                            }))
                                          }
                                          // onChange={(e) => {
                                          //   setFieldValue(
                                          //     `commissionsAndPrograms[${index}].program`,
                                          //     e.target.value
                                          //   );
                                          // }}
                                          // label={"Program"}
                                          fullWidth={true}
                                          helperText={
                                            <Typography
                                              align="left"
                                              // className="px-3"
                                              color={ThemeColor.RED}
                                              fontSize={fontSize.h4.medium}
                                              fontFamily={FontFamily.Lato}
                                              fontWeight={fontWeight.W500}
                                            >
                                              {
                                                errors.commissionsAndPrograms?.[
                                                  index
                                                ]?.program
                                              }
                                            </Typography>
                                          }
                                        />
                                      </div>
                                    </FormGroup>
                                  </NoPaddingGridItem>

                                  <NoPaddingGridItem
                                    item
                                    lg={4}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                  >
                                    <FormGroup style={{}}>
                                      <div className="mt-2">
                                        <Typography
                                          className="mb-1"
                                          fontFamily={FontFamily.Lato}
                                          fontSize={fontSize.h3.medium}
                                          fontWeight={fontWeight.W400}
                                        >
                                          Commision Type
                                        </Typography>
                                        <CustomSelect
                                          value={
                                            values.commissionsAndPrograms[index]
                                              ?.commissionType
                                          }
                                          name={"commissionType"}
                                          multiple={false}
                                          option={[
                                            { _id: "F", title: "Fixed" },
                                            { _id: "P", title: "Percentage" },
                                            { _id: "C", title: "Custom" },
                                            { _id: "S", title: "Scholarship" },
                                          ]}
                                          onChange={(e) => {
                                             const selectedType = e.target.value;
                                             setFieldValue(
                                               `commissionsAndPrograms[${index}].commissionType`,
                                               selectedType
                                             );
                                             if (selectedType === "S") {
                                               setFieldValue(
                                                 `commissionsAndPrograms[${index}].value`,
                                                 0
                                               );
                                             }
                                             if (selectedType === "C") {
                                               const cycles =
                                                 Number(
                                                   values.commissionsAndPrograms[
                                                     index
                                                   ]?.paymentCycle
                                                 ) || 0;
                                               const existing =
                                                 values.commissionsAndPrograms[
                                                   index
                                                 ]?.customValue || [];
                                               setFieldValue(
                                                 `commissionsAndPrograms[${index}].customValue`,
                                                 Array.from(
                                                   { length: cycles },
                                                   (_, i) => existing[i] ?? ""
                                                 )
                                               );
                                             }
                                             // setCommissionType(e.target.value)
                                           }}
                                          label={"Commission Type"}
                                          fullWidth={true}
                                          helperText={
                                            <Typography
                                              align="left"
                                              // className="px-3"
                                              color={ThemeColor.RED}
                                              fontSize={fontSize.h4.medium}
                                              fontFamily={FontFamily.Lato}
                                              fontWeight={fontWeight.W500}
                                            >
                                              {
                                                errors.commissionsAndPrograms?.[
                                                  index
                                                ]?.commissionType
                                              }
                                            </Typography>
                                          }
                                        />
                                      </div>
                                    </FormGroup>
                                  </NoPaddingGridItem>
                                  {values.commissionsAndPrograms[index]
                                    ?.commissionType !== "C" && (
                                      <NoPaddingGridItem
                                        item
                                        lg={4}
                                        md={4}
                                        sm={12}
                                        xs={12}
                                      >
                                        <FormGroup style={{}}>
                                          <div className="">
                                            <Typography
                                              className="mb-2"
                                              fontFamily={FontFamily.Lato}
                                              fontSize={fontSize.h3.medium}
                                              fontWeight={fontWeight.W400}
                                            >
                                              Value
                                            </Typography>
                                            <div className="d-flex align-item-center">
                                              <OutlinedInputField
                                                value={
                                                  values.commissionsAndPrograms[
                                                    index
                                                  ].value
                                                }
                                                name={`commissionsAndPrograms[${index}].value`}
                                                onChange={handleChange}
                                                placeholder="Enter your details...."
                                                fullWidth={true}
                                                disabled={
                                                   values.commissionsAndPrograms[
                                                     index
                                                   ]?.commissionType === "S"
                                                 }
                                                helperText={
                                                  <Typography
                                                    align="left"
                                                    // className="px-3"
                                                    color={ThemeColor.RED}
                                                    fontSize={fontSize.h4.medium}
                                                    fontFamily={FontFamily.Lato}
                                                    fontWeight={fontWeight.W500}
                                                  >
                                                    {
                                                      errors
                                                        .commissionsAndPrograms?.[
                                                        index
                                                      ]?.value
                                                    }
                                                  </Typography>
                                                }
                                              />
                                              <Typography
                                                className=" px-2"
                                                sx={{
                                                  fontSize: fontSize.h3.large,
                                                  fontWeight: fontWeight.W600,
                                                }}
                                              >
                                                {values.commissionsAndPrograms[
                                                  index
                                                ].commissionType === "P"
                                                  ? "%"
                                                  : `${Currencylist &&
                                                  Currencylist?.filter(
                                                    (curr) =>
                                                      curr._id ===
                                                      values.currency
                                                  )?.[0]?.symbol
                                                  }`}
                                              </Typography>
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </NoPaddingGridItem>
                                    )}



                                  <NoPaddingGridItem
                                    item
                                    lg={4}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                  >
                                    <FormGroup style={{}}>
                                      <div className="">
                                        <Typography
                                          className="mb-1"
                                          fontFamily={FontFamily.Lato}
                                          fontSize={fontSize.h3.medium}
                                          fontWeight={fontWeight.W400}
                                        >
                                          Duration
                                        </Typography>
                                        <CustomSelect
                                          value={
                                            values.commissionsAndPrograms[index]
                                              ?.duration
                                          }
                                          name={"duration"}
                                          multiple={false}
                                          option={[
                                            {
                                              _id: "S",
                                              title: "Semester-wise",
                                            },
                                            { _id: "Y", title: "Year-wise" },
                                          ]}
                                          onChange={(e) => {
                                            setFieldValue(
                                              `commissionsAndPrograms[${index}].duration`,
                                              e.target.value
                                            );
                                          }}
                                          label={"Duration"}
                                          fullWidth={true}
                                          helperText={
                                            <Typography
                                              align="left"
                                              // className="px-3"
                                              color={ThemeColor.RED}
                                              fontSize={fontSize.h4.medium}
                                              fontFamily={FontFamily.Lato}
                                              fontWeight={fontWeight.W500}
                                            >
                                              {
                                                errors.commissionsAndPrograms?.[
                                                  index
                                                ]?.duration
                                              }
                                            </Typography>
                                          }
                                        />
                                      </div>
                                    </FormGroup>
                                  </NoPaddingGridItem>

                                  <NoPaddingGridItem
                                    item
                                    lg={4}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                  >
                                    <FormGroup style={{}}>
                                      <div className="">
                                        <Typography
                                          className="mb-2"
                                          fontFamily={FontFamily.Lato}
                                          fontSize={fontSize.h3.medium}
                                          fontWeight={fontWeight.W400}
                                        >
                                          Payment Cycle
                                        </Typography>
                                        <OutlinedInputField
                                          type={"number"}
                                          value={
                                            values.commissionsAndPrograms[index]
                                              ?.paymentCycle
                                          }
                                          name={`commissionsAndPrograms[${index}].paymentCycle`}
                                          onChange={(e) => {
                                            handleChange(e);
                                            if (
                                              values.commissionsAndPrograms[
                                                index
                                              ]?.commissionType === "C"
                                            ) {
                                              const cycles =
                                                Number(e.target.value) || 0;
                                              const existing =
                                                values.commissionsAndPrograms[
                                                  index
                                                ]?.customValue || [];
                                              setFieldValue(
                                                `commissionsAndPrograms[${index}].customValue`,
                                                Array.from(
                                                  { length: cycles },
                                                  (_, i) => existing[i] ?? ""
                                                )
                                              );
                                            }
                                          }}
                                          placeholder="Enter your payment cycle details...."
                                          fullWidth={true}
                                          helperText={
                                            <Typography
                                              align="left"
                                              // className="px-3"
                                              color={ThemeColor.RED}
                                              fontSize={fontSize.h4.medium}
                                              fontFamily={FontFamily.Lato}
                                              fontWeight={fontWeight.W500}
                                            >
                                              {
                                                errors.commissionsAndPrograms?.[
                                                  index
                                                ]?.paymentCycle
                                              }
                                            </Typography>
                                          }
                                        />
                                      </div>
                                    </FormGroup>
                                  </NoPaddingGridItem>

                                  {values.commissionsAndPrograms[index]
                                    .commissionType === "C" &&
                                    Array.from({
                                      length:
                                        Number(
                                          values.commissionsAndPrograms[index]
                                            ?.paymentCycle
                                        ) || 0,
                                    }).map((_, cycleIndex) => (
                                      <NoPaddingGridItem
                                        key={cycleIndex}
                                        item
                                        lg={4}
                                        md={4}
                                        sm={12}
                                        xs={12}
                                      >
                                        <FormGroup>
                                          <div>
                                            <Typography
                                              className="mb-2"
                                              fontFamily={FontFamily.Lato}
                                              fontSize={fontSize.h3.medium}
                                              fontWeight={fontWeight.W400}
                                            >
                                              Custom Value {cycleIndex + 1}
                                            </Typography>

                                            <OutlinedInputField
                                              type={"number"}

                                              value={
                                                values.commissionsAndPrograms[
                                                  index
                                                ].customValue?.[cycleIndex] ||
                                                ""
                                              }
                                              name={`commissionsAndPrograms[${index}].customValue[${cycleIndex}]`}
                                              onChange={handleChange}
                                              placeholder={`Enter custom value for cycle ${cycleIndex + 1
                                                }`}
                                              fullWidth
                                              helperText={
                                                <Typography
                                                  align="left"
                                                  color={ThemeColor.RED}
                                                  fontSize={fontSize.h4.medium}
                                                  fontFamily={FontFamily.Lato}
                                                  fontWeight={fontWeight.W500}
                                                >
                                                  {Array.isArray(
                                                    errors
                                                      .commissionsAndPrograms?.[
                                                      index
                                                    ]?.customValue
                                                  )
                                                    ? errors
                                                        .commissionsAndPrograms?.[
                                                        index
                                                      ]?.customValue?.[
                                                        cycleIndex
                                                      ]
                                                    : errors
                                                        .commissionsAndPrograms?.[
                                                        index
                                                      ]?.customValue}
                                                </Typography>
                                              }
                                            />
                                          </div>
                                        </FormGroup>
                                      </NoPaddingGridItem>
                                    ))}

                                  <NoPaddingGridItem
                                    item
                                    lg={4}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                  >
                                    <FormGroup className="w-100" style={{}}>
                                      <div className="w-100">
                                        <Typography
                                          className="mb-2"
                                          fontFamily={FontFamily.Lato}
                                          fontSize={fontSize.h3.medium}
                                          fontWeight={fontWeight.W400}
                                        >
                                          Terms And Conditions for university
                                        </Typography>
                                        {/* <OutlinedInputField
                                          value={
                                            values.commissionsAndPrograms[index]
                                              .termsAndCondition
                                          }
                                          name={`commissionsAndPrograms[${index}].termsAndCondition`}
                                          onChange={handleChange}
                                          placeholder="Enter your terms and condition details...."
                                          fullWidth={true}
                                          helperText={
                                            <Typography
                                              align="left"
                                              // className="px-3"
                                              color={ThemeColor.RED}
                                              fontSize={fontSize.h4.medium}
                                              fontFamily={FontFamily.Lato}
                                              fontWeight={fontWeight.W500}
                                            >
                                              {
                                                errors.commissionsAndPrograms?.[
                                                  index
                                                ]?.termsAndCondition
                                              }
                                            </Typography>
                                          }
                                        /> */}
                                        <OutlinedTextAreaField
                                          multiline={true}
                                          minRows={4}
                                          value={
                                            values.commissionsAndPrograms[index]
                                              .termsAndCondition
                                          }
                                          name={`commissionsAndPrograms[${index}].termsAndCondition`}
                                          // onChange={(e)=>
                                          // {
                                          //   console.log(e)
                                          //   // setFieldValue(`commissionsAndPrograms[${index}].termsAndCondition`,e.target.value)
                                          // }}
                                          onChange={handleChange}
                                          placeholder="Enter your terms and condition details...."
                                          fullWidth={true}
                                          helperText={
                                            <Typography
                                              align="left"
                                              // className="px-3"
                                              color={ThemeColor.RED}
                                              fontSize={fontSize.h4.medium}
                                              fontFamily={FontFamily.Lato}
                                              fontWeight={fontWeight.W500}
                                            >
                                              {
                                                errors.commissionsAndPrograms?.[
                                                  index
                                                ]?.termsAndCondition
                                              }
                                            </Typography>
                                          }
                                        />
                                      </div>
                                    </FormGroup>
                                  </NoPaddingGridItem>

                                  <NoPaddingGridItem
                                    item
                                    lg={4}
                                    md={4}
                                    sm={12}
                                    xs={12}
                                  >
                                    <FormGroup style={{}}>
                                      <div className="">
                                        <Typography
                                          className="mb-2"
                                          fontFamily={FontFamily.Lato}
                                          fontSize={fontSize.h3.medium}
                                          fontWeight={fontWeight.W400}
                                        >
                                          Terms And Conditions for organization
                                        </Typography>
                                        {/* <OutlinedInputField
                                          value={
                                            values.commissionsAndPrograms[index]
                                              .termsAndConditionForOrg
                                          }
                                          name={`commissionsAndPrograms[${index}].termsAndConditionForOrg`}
                                          onChange={handleChange}
                                          placeholder="Enter your terms and condition details...."
                                          fullWidth={true}
                                          helperText={
                                            <Typography
                                              align="left"
                                              // className="px-3"
                                              color={ThemeColor.RED}
                                              fontSize={fontSize.h4.medium}
                                              fontFamily={FontFamily.Lato}
                                              fontWeight={fontWeight.W500}
                                            >
                                              {
                                                errors.commissionsAndPrograms?.[
                                                  index
                                                ]?.termsAndConditionForOrg
                                              }
                                            </Typography>
                                          }
                                        /> */}
                                        <OutlinedTextAreaField
                                          multiline={true}
                                          minRows={4}
                                          value={
                                            values.commissionsAndPrograms[index]
                                              .termsAndConditionForOrg
                                          }
                                          name={`commissionsAndPrograms[${index}].termsAndConditionForOrg`}
                                          onChange={handleChange}
                                          placeholder="Enter your terms and condition details...."
                                          fullWidth={true}
                                          helperText={
                                            <Typography
                                              align="left"
                                              // className="px-3"
                                              color={ThemeColor.RED}
                                              fontSize={fontSize.h4.medium}
                                              fontFamily={FontFamily.Lato}
                                              fontWeight={fontWeight.W500}
                                            >
                                              {
                                                errors.commissionsAndPrograms?.[
                                                  index
                                                ]?.termsAndConditionForOrg
                                              }
                                            </Typography>
                                          }
                                        />
                                      </div>
                                    </FormGroup>
                                  </NoPaddingGridItem>

                                  {index > 0 && (
                                    <NoPaddingGridItem
                                      item
                                      lg={3}
                                      md={3}
                                      sm={12}
                                      xs={12}
                                      className="d-flex align-items-center"
                                    >
                                      <div className="d-flex justify-content-start w-100 mt-3">
                                        <Typography
                                          className="px-2"
                                          fontSize={fontSize.h3.small}
                                          fontFamily={FontFamily.Lato}
                                          color={ThemeColor.BLACK}
                                          fontWeight={fontWeight.W600}
                                        >
                                          Delete Commission and Program
                                        </Typography>
                                        <IconButton
                                          className="form-icon"
                                          sx={{
                                            background: ThemeColor.RED,
                                            color: ThemeColor.WHITE,
                                          }}
                                          variant="contained"
                                          onClick={() => remove(index)}
                                        >
                                          <RemoveIcon />
                                        </IconButton>
                                      </div>
                                    </NoPaddingGridItem>
                                  )}
                                </Grid>
                              )
                            )}
                            <div className="d-flex justify-content-end w-100 mt-3">
                              <Typography
                                className="px-2"
                                fontSize={fontSize.h3.small}
                                fontFamily={FontFamily.Lato}
                                color={ThemeColor.BLACK}
                                fontWeight={fontWeight.W600}
                              >
                                Add Commission and Program
                              </Typography>
                              <IconButton
                                className="form-icon"
                                sx={{
                                  background: ThemeColor.BLUE,
                                  color: ThemeColor.WHITE,
                                }}
                                onClick={() =>
                                  push({
                                    degree: "",
                                    program: [],
                                    commissionType: "",
                                    value: "",
                                    duration: "",
                                    termsAndCondition: "",
                                    paymentCycle: "",
                                    termsAndConditionForOrg: "",
                                    isNew: true,
                                  })
                                }
                              >
                                <AddIcon />
                              </IconButton>
                            </div>
                          </div>
                        )}
                      </FieldArray>
                    </Grid>
                  )}
              </Grid>

          </div>
        </Form>
      )}
    </Formik>
  );
};

function CreateUniversity() {
  return (
    <div>
      <ResponsiveDrawer maincontent={<CreateUniversityPage />} />
    </div>
  );
}

export default CreateUniversity;
